import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { GiftRecommendedItemRow } from '@models/item/recommendedItem';
import { Link } from '@stackflow/link';

interface Props {
    item: GiftRecommendedItemRow;
}

function GiftItem({ item }:Props) {
    const {
        name, salePrice, thumbnailUrl, itemId,
    } = item;
    return (
        <Link activityName='GiftItemActivity'
            activityParams={{ giftItemId: itemId }}>
            <Container align='center'>
                <ImageWrapper>
                    <Image src={thumbnailUrl}
                        width={88}
                        height={88}
                        alt={name} />
                </ImageWrapper>
                <Text>{name}</Text>
                <Text size='lg' fontWeight='bold'>
                    {salePrice.toLocaleString()}
                </Text>
            </Container>
        </Link>
    );
}

const Container = styled(Column)`
    scroll-snap-stop: always;
    scroll-snap-align: start;
`;

const ImageWrapper = styled.div`
    align-items: center;
    border-radius: 10px;
    box-shadow: 0 0px 4.95px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    height: 110px;
    justify-content: center;
    margin-bottom: 6px;
    width: 110px;
`;

export default GiftItem;
